import React, { useEffect, useState, useRef } from 'react';

import axios from 'axios';
import Minibar from '../../../components/navbar/Minibar.js';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage.js';
import CardSite from '../../../components/card/CardSite.js';
import moment from 'moment'

function SiteHealth(props) {
    let ismount = useRef(true);
    let isfetch = useRef(false);
    let isfirst = useRef(true);
    let ischeck = useRef(false);

    const hot_update_health = useRef('-')
    const hot_update_iot = useRef('-')
    const [server_update_health, setServerUpdate_health] = useState(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"))
    const [server_update_iot, setServerUpdate_iot] = useState(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"))
    const [submenu_root, setSubmenu_root] = useState('Site Health');
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [data_site, setData_site] = useState([])
    const [data_iot, setData_iot] = useState([])
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    useEffect(() => {
        ismount.current = true
        if (!isfetch.current) {
            api_get_sitehealth()
        }
    }, [props.center_hot_update]);

    useEffect(() => {
        return () => {
            ismount.current = false
            setData_site([])
        };
    }, []);

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    async function api_get_sitehealth() {
        if (isfirst.current) {
            // setmodal_load({ enable: true, message: "Loading site health data.." })
        }
        isfetch.current = true
        const formData = new FormData()
        formData.append('sitelist', props.permitdata?.sitescope_str)
        formData.append('update_key_health', hot_update_health.current)
        formData.append('update_key_iot', hot_update_iot.current)
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/sitedata/sitehealth", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer GrU5w8y8CKjQPoBCfkjI8fAaoFUP6KLg5xG6h0pfJ2pbfgkPKCc8k522Z7wxy6xb"
            },
        })
            .then((response) => {
                isfetch.current = false
                isfirst.current = false
                if (!ischeck.current) {
                    setmodal_load({ enable: false, message: "" })
                }
                if (ismount.current) {
                    if (response.data.status === 'OK') {
                        if (response.data.healthdata !== undefined) {
                            if (response.data.healthdata !== null) {
                                setData_site(response.data.healthdata)
                            }
                        }
                        if (response.data.iotdata !== undefined) {
                            if (response.data.iotdata !== null) {
                                setData_iot(response.data.iotdata)
                            }
                        }
                        if (response.data.update_key_health !== undefined) {
                            hot_update_health.current = response.data.update_key_health
                            setServerUpdate_health(response.data.update_key_health)
                        }
                        if (response.data.update_key_iot !== undefined) {
                            hot_update_iot.current = response.data.update_key_iot
                            setServerUpdate_iot(response.data.update_key_iot)
                        }
                    }
                    else {

                    }
                }
            })
            .catch((err) => {
                isfetch.current = false
                isfirst.current = false
                if (!ischeck.current) {
                    setmodal_load({ enable: false, message: "" })
                }
            });
    }

    async function api_check_online(sitecode, sitename_th) {
        ischeck.current = true
        setmodal_load({ enable: true, message: "Connecting to " + sitecode + " " + sitename_th })
        await sleep(500)
        return new Promise((resolve, reject) => {
            const formData = new FormData()
            axios.post(process.env.REACT_APP_API_URL + "/proxy/local/" + sitecode + "/api/authentication/plantinfo", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer GrU5w8y8CKjQPoBCfkjI8fAaoFUP6KLg5xG6h0pfJ2pbfgkPKCc8k522Z7wxy6xb"
                },
            })
                .then((response) => {
                    ischeck.current = false
                    if (ismount.current) {
                        setmodal_load({ enable: false, message: "" })
                        if (response.data.status === 'OK') {
                            resolve(true)
                        }
                        else {
                            resolve(false)
                        }
                    }
                    resolve(false)
                })
                .catch((err) => {
                    if (ismount.current) {
                        setmodal_load({ enable: false, message: "" })
                        ischeck.current = false
                        resolve(false)
                    }
                });
        })
    }

    async function check_site(sitecode, sitename_en, sitename_th, api_url) {
        var state = await api_check_online(sitecode, sitename_th)
        if (state) {
            props.callback_select_site(sitecode, sitename_en, sitename_th, api_url, "/appcenter/dashboard/sitehealth")
        } else {
            setModal_popup({
                modaltype: 'modal-error',
                headers: 'Site Access Problem',
                message: 'Sorry! Can not access to local site at this time, it\'s seem like connection between central and local has been lose. \r\nPlease try again or contact your system administrator.',
                enable: true
            });
        }
    }

    function getIOTdata(iot_data, sitecode) {
        const firstActiveItem = iot_data.filter(item => item.SiteCode === sitecode)[0];
        return firstActiveItem
    }

    return (
        <section id="content" className="content">
            <Minibar
                main_root={"Realtime Dashboard"}
                submenu_root={submenu_root}
                systemtime={props.data_systemdatetime}
            />
            <div className="content__boxed d-md-flex h-100">
                <div className="content__wrap order-2 flex-fill min-w-0 hi-100 border-left">
                    <div id="page-content">
                        <div className="panel">
                            <div className="panel-body">
                                <div className="row mb-2">
                                    <div className="col-xl-12">
                                        <h4 className="mb-1"><i className="fas fa-headset"></i> Site Health</h4>
                                        <p className="mb-1">Quick monitoring for all sites health</p>
                                        <h6 className='mb-0'><i className="mdi mdi-clock-time-four-outline"></i> Update : {moment(new Date(server_update_health)).format("YYYY-MM-DD HH:mm:ss")}</h6>
                                        <hr className="new-section-xs mb-2" />
                                    </div>
                                </div>

                                <div className="d-flex flex-wrap">
                                    {
                                        data_site?.map((data, index) => (
                                            data.SiteCode !== "-" && data.SiteCode !== "" ?
                                                <div className="health-box" key={data.SiteCode}>
                                                    <CardSite
                                                        iotdata={getIOTdata(data_iot, data.SiteCode)}
                                                        sitedata={data}
                                                        onSelected={(sitecode, sitename_en, sitename_th, api_url) => { check_site(sitecode, sitename_en, sitename_th, api_url) }}
                                                    />
                                                </div>
                                                :
                                                null
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </section>
    )
}
export default SiteHealth